import { QueryClient, QueryClientProvider } from 'react-query';
import { useTokenExpiration } from '../hooks/useTokenExpiration';
import { AuthProvider } from '../auth/context/AuthProvider';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { TokenExpired } from '../components/TokenExpired';
import { Login } from '../auth/pages/Login';
import ProtectedRoute from '../components/ProtectedRoute';
import StreamingAdmin from '../pages/StreamingAdmin/StreamingAdmin';
import { ConfigGeneralProvider } from '../auth/context/ConfigGeneral/ConfigGeneralProvider';
const queryClient = new QueryClient();
export { queryClient };

export const AppRoutes = () => {

    //Proceso para validar token de autenticacion
    const { checkTokenExpiration, showModalExpirated } = useTokenExpiration();
    useEffect(() => {
        checkTokenExpiration();
    }, [showModalExpirated]);

    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <ConfigGeneralProvider>
                    <div className={`bg-slate-600 text-black`}>
                        {showModalExpirated && <TokenExpired />}
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route element={<ProtectedRoute />}>
                                <Route path="/streaming-admin" element={<StreamingAdmin />} />
                            </Route>
                            <Route path="*" element={<Navigate replace to="/login" />} />
                        </Routes>
                    </div>
                </ConfigGeneralProvider>
            </AuthProvider>
        </QueryClientProvider>
    )
}
